import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TerminationList.css";
import { Link } from "react-router-dom"; // File untuk styling
import Pagination from "react-bootstrap/Pagination";
import { useNavigate } from "react-router-dom";
import moment from 'moment-timezone';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";


function TerminationList() {
  const [tokenNow, setTokenNow] = useState("");
  const [authByToken, setAuthByToken] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const loadUserByToken = async (token) => {
    const result = await axios.get(
      `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`
    );
    setAuthByToken(result.data[0]);
  };

  const [terminationList, setTerminationList] = useState([]);
  const [status, setStatus] = useState([]);
  const [selectedOption, setSelectedOption] = useState("keyTerminationDate");

  // order date
  const [selectedOrderDateFrom, setSelectedOrderDateFrom] = useState("");
  const [inputOrderDateFrom, setInputOrderDateFrom] = useState("");
  const [selectedOrderDateUntil, setSelectedOrderDateUntil] = useState("");
  const [inputOrderDateUntil, setInputOrderDateUntil] = useState("");

  // status
  const [selectedStatus, setSelectedStatus] = useState("");
  const [inputStatus, setInputStatus] = useState("");

  // Requestor
  const [selectedRequestor, setSelectedRequestor] = useState("");
  const [inputRequestor, setInputRequestor] = useState("");

  // Cable Id
  const [selectedCableId, setSelectedCableId] = useState("");
  const [inputCableId, setInputCableId] = useState("");

  // Id
  const [selectedId, setSelectedId] = useState("");
  const [inputId, setInputId] = useState("");

  const resource = "termination-list";
  const storedToken = localStorage.getItem("token");

  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFail, setOpenFail] = useState(false);

  const [cancelTerminationId, setCancelTerminationId] = useState("");

  useEffect(() => {
    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();

    if (storedToken) {
      loadUserByToken(storedToken);
    }

    setTokenNow(storedToken);
    loadStatus();
    defaultPage(storedToken);
  }, []);

  function defaultPage(storedToken) {
    // Mendapatkan tanggal hari ini
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const todayFormatted = tomorrow.toISOString().split("T")[0];

    // Mendapatkan tanggal 30 hari sebelum hari ini
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 30);
    const pastDateFormatted = pastDate.toISOString().split("T")[0];

    setInputOrderDateFrom(pastDateFormatted);
    setInputOrderDateUntil(todayFormatted);
    loadTerminationList(
      selectedOption,
      pastDateFormatted,
      todayFormatted,
      storedToken
    );
  }

  useEffect(() => {
    if (selectedStatus !== "") {
      loadTerminationList(selectedOption, selectedStatus);
    } else if (selectedCableId !== "") {
      loadTerminationList(selectedOption, selectedCableId);
    } else if (selectedRequestor !== "") {
      loadTerminationList(selectedOption, selectedRequestor);
    } else if (selectedOrderDateFrom !== "" && selectedOrderDateUntil !== "") {
      loadTerminationList(
        selectedOption,
        selectedOrderDateFrom,
        selectedOrderDateUntil
      );
    } else if (selectedId !== "") {
      loadTerminationList(selectedOption, selectedId);
    }
  }, [
    selectedOrderDateFrom,
    selectedOrderDateUntil,
    selectedStatus,
    selectedCableId,
    selectedRequestor,
    selectedId,
    tokenNow,
  ]);

  const resetFiltersExcept = (filterType) => {
    if (filterType !== "status") {
      setSelectedStatus("");
      setInputStatus("");
    }

    if (filterType !== "cableId") {
      setSelectedCableId("");
      setInputCableId("");
    }

    if (filterType !== "requestor") {
      setSelectedRequestor("");
      setInputRequestor("");
    }

    if (filterType !== "orderDate") {
      setSelectedOrderDateFrom("");
      setInputOrderDateFrom("");
      setSelectedOrderDateUntil("");
      setInputOrderDateUntil("");
    }

    if (filterType !== "id") {
      setSelectedId("");
      setInputId("");
    }
  };

  const loadTerminationList = async (key, value1, value2, token) => {
    try {
      if (tokenNow !== "" && tokenNow !== null) {
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-list?param1=${key}&param2=${value1}&param3=${value2}&token=${tokenNow}`
        );
        const data = result.data;
        setTerminationList(data);
      } else {
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-list?param1=${key}&param2=${value1}&param3=${value2}&token=${token}`
        );
        const data = result.data;
        setTerminationList(data);
      }
    } catch (error) {
      console.error("Error loading order list:", error);
    }
  };

  const loadStatus = async () => {
    const result = await axios.get(
      "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/termination-status/find-all"
    );
    const data = result.data.body;
    setStatus(data);
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const handleSelectChange = (event) => {
    setCurrentPage(1);
    setSelectedOption(event.target.value);
  };

  //   order date
  const handleOrderDateFromChange = (event) => {
    setCurrentPage(1);
    setInputOrderDateFrom(event.target.value);
  };
  const handleOrderDateUntilChange = (event) => {
    setCurrentPage(1);
    setInputOrderDateUntil(event.target.value);
  };

  // status
  const handleStatusChange = (event) => {
    setCurrentPage(1);
    setInputStatus(event.target.value);
  };

  // cable id
  const handleCableIdChange = (event) => {
    setCurrentPage(1);
    setInputCableId(event.target.value);
  };

  // requestor
  const handleRequestorChange = (event) => {
    setCurrentPage(1);
    setInputRequestor(event.target.value);
  };

  // id
  const handleIdChange = (event) => {
    setCurrentPage(1);
    setInputId(event.target.value);
  };

  const handleSubmitStatus = (event) => {
    event.preventDefault();
    resetFiltersExcept("status");
    setSelectedStatus(inputStatus);
  };

  const handleSubmitRequestor = (event) => {
    event.preventDefault();
    resetFiltersExcept("requestor");
    setSelectedRequestor(inputRequestor);
  };

  const handleSubmitCableId = (event) => {
    event.preventDefault();
    resetFiltersExcept("cableId");
    setSelectedCableId(inputCableId);
  };

  const handleSubmitOrderDate = (event) => {
    event.preventDefault();
    resetFiltersExcept("orderDate");
    setSelectedOrderDateFrom(inputOrderDateFrom);
    setSelectedOrderDateUntil(inputOrderDateUntil);
  };

  const handleSubmitId = (event) => {
    event.preventDefault();
    resetFiltersExcept("id");
    setSelectedId(inputId);
  };

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 25;

  // Get current orders
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentTerminationList = terminationList.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate pagination items
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(terminationList.length / ordersPerPage); i++) {
    pageNumbers.push(i);
  }

  const renderPaginationItems = () => {
    const paginationItems = [];
    let ellipsisShown = false;

    for (let i = 1; i <= pageNumbers.length; i++) {
      if (
        i === 1 ||
        i === pageNumbers.length ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        paginationItems.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => paginate(i)}
          >
            {i}
          </Pagination.Item>
        );
        ellipsisShown = false;
      } else if (!ellipsisShown) {
        paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
        ellipsisShown = true;
      }
    }

    return paginationItems;
  };

  const downloadInstallation = async (terminationId) => {
      try {
        // Step 1: Get the presigned download URL from your Lambda function
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/download-installation?terminationId=${terminationId}`
        );
        const downloadUrl = result.data.downloadUrl;
  
        // Step 2: Fetch the file from the presigned URL
        const response = await fetch(downloadUrl, {
          method: "GET", // Use GET to download the file
        });
  
        const fileName = result.data.fileName;
  
        // Step 3: Convert the response to a Blob and create a downloadable link
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Set the desired file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up after download
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };

  const cancelTermination = async (terminationorderId) => {
    setCancelTerminationId(terminationorderId);
    setOpenConfirm(true);  
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenFail(false)
  };

  function inputSuccess(){
    setOpenSuccess(false);
    window.location.reload();
  }

  const handleCancelTermination = async (event) => {
    const currentDate = new Date().toISOString().split("T")[0];

      const cancelTermination = {
        termination_id: cancelTerminationId,
        email_requestor: authByToken.email,
        cancel_termination_date: getDateTimeInUserTimeZone(currentDate),
      };
      try {
        const response = await fetch('https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/cancel-termination', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(cancelTermination)
        });

        const data = await response.json();
        const responseBody = JSON.parse(data.body);

        if (!response.ok) {
          throw new Error('Failed to cancel termination');
        }

        const { message } = responseBody;
        if (message == 'success'){

        setOpenConfirm(false)
        setOpenSuccess(true)
        }else{
        setOpenConfirm(false)
        setOpenFail(true)
        }
      } catch (error) {
        setError('Cancel Termination Error: ' + error.message);
        console.error('Cancel Termination Error:', error.message);
        setOpenConfirm(false)
        setOpenFail(true)
      }
  };

  function getDateTimeInUserTimeZone(date) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");

    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${date}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");

    return dateTimeInUserTimeZone;
  }

  const downloadInternalTerminationLetter = async (terminationId) => {
    try {
      // Step 1: Get the presigned download URL from your Lambda function
      const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/download-internal-termination-letter?terminationId=${terminationId}`); 
      const downloadUrl = result.data.downloadUrl;
  
      // Step 2: Fetch the file from the presigned URL
      const response = await fetch(downloadUrl, {
        method: 'GET', // Use GET to download the file
      });

      const fileName = result.data.fileName;
  
      // Step 3: Convert the response to a Blob and create a downloadable link
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="container-termination-list">
      {/*<update-code */}
      <input type="hidden" name="token" value={tokenNow} />{" "}
      {/* Hidden token field */}
      {/* update-code>*/}
      <h1>Cross Connect Termination List</h1>
      <div className="title-order-input">
        <h6>Fulfill filter information to show termination data.</h6>
        <h5>Filter</h5>
      </div>
      <form>
        <div className="textbox-termination-list">
          <label htmlFor="comboBox">Key</label>
          <select id="comboBox" name="options" onChange={handleSelectChange}>
            <option value="keyTerminationDate">Termination Date</option>
            <option value="keyCableId">Cable Id</option>
            <option value="keyRequestor">Requestor</option>
            <option value="keyStatus">Status</option>
            <option value="keyId">Id</option>
          </select>
        </div>
        {selectedOption === "key0" &&
          selectedOption !== "keyStatus" &&
          selectedOption !== "keyRequestor" &&
          selectedOption !== "keyDestination" &&
          selectedOption !== "keyRequestorPic" &&
          selectedOption !== "keyDestinationPic" &&
          selectedOption !== "keyCrossConnectType" &&
          selectedOption !== "keyId" && (
            <div className="value-order-list">
              <div className="textbox-termination-list">
                <label htmlFor="Value">Value</label>
                <input type="text" placeholder="Value" />
              </div>
              <input
                type="submit"
                className="btn-submit-termination-list"
                value="Search"
              />
            </div>
          )}
      </form>
      {selectedOption === "keyTerminationDate" && (
        <form onSubmit={handleSubmitOrderDate}>
          <div className="textbox-termination-list-date">
            <label htmlFor="orderDate">Termination Date</label>
            <input
              type="date"
              className="dateFilter1"
              id="orderDate"
              value={inputOrderDateFrom}
              onChange={handleOrderDateFromChange}
            />
            <input
              type="date"
              className="dateFilter2"
              id="orderDate"
              value={inputOrderDateUntil}
              onChange={handleOrderDateUntilChange}
            />
          </div>
          <input
            type="submit"
            className="btn-submit-order-list"
            value="Search"
          />
        </form>
      )}
      {selectedOption === "keyCableId" && (
        <form onSubmit={handleSubmitCableId}>
          <div className="textbox-termination-list">
            <label htmlFor="Requestor">Cable Id</label>
            <input
              type="text"
              placeholder="Cable Id"
              value={inputCableId}
              onChange={handleCableIdChange}
            />
          </div>
          <input
            type="submit"
            className="btn-submit-order-list"
            value="Search"
          />
        </form>
      )}
      {selectedOption === "keyRequestor" && (
        <form onSubmit={handleSubmitRequestor}>
          <div className="textbox-termination-list">
            <label htmlFor="Requestor">Requestor</label>
            <input
              type="text"
              placeholder="Requestor"
              value={inputRequestor}
              onChange={handleRequestorChange}
            />
          </div>
          <input
            type="submit"
            className="btn-submit-order-list"
            value="Search"
          />
        </form>
      )}
      {selectedOption === "keyId" && (
        <form onSubmit={handleSubmitId}>
          <div className="textbox-termination-list">
            <label htmlFor="Requestor PIC">Id</label>
            <input
              type="number"
              placeholder="Id"
              value={inputId}
              onChange={handleIdChange}
            />
          </div>
          <input
            type="submit"
            className="btn-submit-order-list"
            value="Search"
          />
        </form>
      )}
      {selectedOption === "keyStatus" && (
        <form onSubmit={handleSubmitStatus}>
          <div className="value-status">
            <div className="textbox-termination-list">
              <label htmlFor="comboBox">Status</label>
              <select
                id="comboBox"
                name="options"
                value={inputStatus}
                onChange={handleStatusChange}
              >
                <option hidden>Select Termination Status</option>
                {status.map((item) => (
                  <option
                    key={item.xcp_termination_status_id}
                    value={item.xcp_termination_status_id}
                  >
                    {item.xcp_termination_status_name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="submit"
              className="btn-submit-order-list"
              value="Search"
            />
          </div>
        </form>
      )}
      <table className="table table-bordered">
        <thead>
          <tr>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Id</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Termination Date</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Cable Id</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Requestor</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Status</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}} colSpan="8">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {currentTerminationList.map((order) => {
            const showCreateTerminationLetter =
              authByToken.xcp_role_code === "XCPRLE-002" &&
              order.termination_status_code === "XCPTTS-001" ;
            
              const showDownloadInternalTerminationLetter =
              (authByToken.xcp_role_code === "XCPRLE-002" || authByToken.xcp_role_code === "XCPRLE-003" || authByToken.xcp_role_code === "XCPRLE-004") &&
              (order.termination_status_code === "XCPTTS-002" || order.termination_status_code === "XCPTTS-003" || order.termination_status_code === "XCPTTS-004" || order.termination_status_code === "XCPTTS-005" || order.termination_status_code === "XCPTTS-099");
            
              const showUpdate =
              authByToken.xcp_role_code === "XCPRLE-001" &&
              order.termination_status_code === "XCPTTS-004" ;

            const showFeedback =
              (order.termination_status_code === "XCPTTS-002" &&
                authByToken.xcp_role_code === "XCPRLE-003") ||
              (order.termination_status_code === "XCPTTS-003" &&
                authByToken.xcp_role_code === "XCPRLE-004");

            const ShowUploadInstallation =
              authByToken.xcp_role_code === "XCPRLE-004" &&
              order.termination_status_code === "XCPTTS-005";

            const showDownloadInstallation =
                (authByToken.xcp_role_code === 'XCPRLE-001'  ||
                authByToken.xcp_role_code === 'XCPRLE-002' || authByToken.xcp_role_code === 'XCPRLE-003' || authByToken.xcp_role_code === 'XCPRLE-004')
                &&
                (order.termination_status_code === 'XCPTTS-099');
            
            const showCancelTermination = (order.termination_status_code === "XCPTTS-001"  || order.termination_status_code === "XCPTTS-002") &&
              authByToken.xcp_role_code === "XCPRLE-001" && authByToken.company_name === order.company_name;  
  
            const handleDisabledClick = (event) => {
              event.preventDefault();
            };

            return (
              <tr key={order.termination_id}>
                <td>{order.termination_id}</td>
                <td>{formatDate(order.termination_date)}</td>
                <td>{order.cable_id}</td>
                <td>{order.company_name}</td>
                <td>{order.termination_status_name}</td>
                <td className="icon-center">
                  <Link to={`/termination-detail?param1=${order.termination_id}`}>
                    <i className="bi bi-eye-fill" title="Detail"></i>
                  </Link>
                </td>
                <td className="icon-center">
                  <Link
                    to={`/update-termination?param1=${order.termination_id}`}
                    onClick={!showUpdate ? handleDisabledClick : undefined}
                    className={!showUpdate ? "disabled-icon" : ""}
                  >
                    <i className="bi bi-pencil-fill" title="Update"></i>
                  </Link>
                </td>
                <td className="icon-center">
                  <Link
                    to={`/create-termination-letter?param1=${order.termination_id}`}
                    onClick={!showCreateTerminationLetter ? handleDisabledClick : undefined}
                    className={!showCreateTerminationLetter ? "disabled-icon" : ""}
                  >
                    <i className="bi bi-envelope-plus" title="Create Termination Letter"></i>
                  </Link>
                </td>
                <td className="icon-center">
                <div
                  onClick={() => {
                      if (showDownloadInternalTerminationLetter) {
                          downloadInternalTerminationLetter(order.termination_id);
                      } else {
                          handleDisabledClick();
                      }
                  }}
                  className={`icon-button ${!showDownloadInternalTerminationLetter ? 'disabled-icon' : ''}`}
                  title="Download Internal Termination Letter"
                  disabled={!showDownloadInternalTerminationLetter}
                >
                    <i className="bi bi-envelope-arrow-down-fill" title="Download Internal Termination Letter"></i>
                </div>
              </td>
                <td className="icon-center">
                  <Link
                    to={`/termination-feedback?param1=${order.termination_id}`}
                    onClick={!showFeedback ? handleDisabledClick : undefined}
                    className={!showFeedback ? "disabled-icon" : ""}
                  >
                    <i
                      className="bi bi-chat-left-text-fill"
                      title="Feedback"
                    ></i>
                  </Link>
                </td>
                <td className="icon-center">
                  <Link
                    to={`/upload-termination-installation?param1=${order.termination_id}`}
                    onClick={
                      !ShowUploadInstallation ? handleDisabledClick : undefined
                    }
                    className={!ShowUploadInstallation ? "disabled-icon" : ""}
                  >
                    <i
                      className="bi bi-clipboard2-check"
                      title="Upload Installation"
                    ></i>
                  </Link>
                </td>
                <td className="icon-center">
                  <div
                    onClick={() => {
                      if (showDownloadInstallation) {
                        downloadInstallation(order.termination_id);
                      } else {
                        handleDisabledClick();
                      }
                    }}
                    className={`icon-button ${
                      !showDownloadInstallation ? "disabled-icon" : ""
                    }`}
                    title="Download Installation"
                    disabled={!showDownloadInstallation}
                  >
                    <i
                      className="bi bi-clipboard2-check-fill"
                      title="Download Installation"
                    ></i>
                  </div>
                </td>
                <td className="icon-center">
                  <div
                    onClick={() => {
                      if (showCancelTermination) {
                        cancelTermination(order.termination_id);
                      } else {
                        handleDisabledClick();
                      }
                    }}
                    className={`icon-button ${
                      !showCancelTermination ? "disabled-icon" : ""
                    }`}
                    title="Cancel Termination"
                    disabled={!showCancelTermination}
                  >
                    <i className="bi bi-x-circle-fill" title="Cancel Termination"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination>
        <Pagination.First onClick={() => paginate(1)} />
        <Pagination.Prev
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
        />
        {renderPaginationItems()}
        <Pagination.Next
          onClick={() =>
            paginate(
              currentPage < pageNumbers.length
                ? currentPage + 1
                : pageNumbers.length
            )
          }
        />
        <Pagination.Last onClick={() => paginate(pageNumbers.length)} />
      </Pagination>

      <Dialog open={openConfirm}>
          <DialogTitle>{"Are you sure you want to cancel this termination?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will cancel this termination.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleCancelTermination} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openSuccess}>
          <DialogTitle>{"Cancel Termination successfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={inputSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openFail}>
        <DialogTitle>{"Cancel Termination Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default TerminationList;
